import {combineReducers} from 'redux'

const rootReducer = combineReducers({foo: () => ({bar: 0})})

export default rootReducer
